import { API } from "@/lib/api";

export const InvoicePreview = ({ invoiceId, contentType, filename }) => {
  const fileUrl = `${API}/invoices/${invoiceId}/file`;
  return (
    <div
      className="bg-white border border-[#DCE3DF] rounded-[10px] shadow-[0_4px_20px_rgba(20,30,26,0.06)] h-full flex flex-col overflow-hidden"
      data-testid="invoice-preview-pane"
    >
      <div className="px-5 py-3 border-b border-[#DCE3DF] flex items-center justify-between">
        <span className="text-xs font-mono uppercase tracking-[0.1em] text-[#5A6B63]">Original Document</span>
        <span className="text-xs font-mono text-[#5A6B63] truncate max-w-[180px]">{filename}</span>
      </div>
      <div className="flex-1 bg-[#EEF1EF] overflow-auto">
        {contentType === "application/pdf" ? (
          <iframe title="invoice-preview" src={fileUrl} className="w-full h-full" data-testid="invoice-preview-pdf" />
        ) : (
          <img src={fileUrl} alt="Uploaded invoice" className="w-full h-auto" data-testid="invoice-preview-image" />
        )}
      </div>
    </div>
  );
};
